// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore"
import { getAuth } from 'firebase/auth'
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBr4qS31HweyG-4U-gTV_ekXnNlS5eyYjA",
  authDomain: "neurocare-8a9f4.firebaseapp.com",
  databaseURL: "https://neurocare-8a9f4-default-rtdb.firebaseio.com",
  projectId: "neurocare-8a9f4",
  storageBucket: "neurocare-8a9f4.firebasestorage.app",
  messagingSenderId: "1048203110302",
  appId: "1:1048203110302:web:e8dc9d0b844601e5a9988f",
  measurementId: "G-3E49YW2648"
};
var firebaseRealDbConfig = {
  apiKey: "AIzaSyBr4qS31HweyG-4U-gTV_ekXnNlS5eyYjA",
  authDomain: "neurocare-8a9f4.firebaseapp.com",
  databaseURL: "https://neurocare-8a9f4.firebaseio.com/",
  projectId: "neurocare-8a9f4",
  storageBucket: "neurocare-8a9f4.firebasestorage.app",
  messagingSenderId: "1048203110302",
  appId: "1:1048203110302:web:e8dc9d0b844601e5a9988f",
  measurementId: "G-3E49YW2648"
};

const app = initializeApp(firebaseConfig, "AppForceClean");  
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
})
const pDb = initializeApp(firebaseRealDbConfig, "patientDb")
const storage = getStorage(app);
export const auth = getAuth(app);
export { db };
export const patientDb = getDatabase(pDb)
export { storage };
// Cloud Functions 호출용. auth와 같은 앱에 묶여 있어야 로그인 토큰이 함께 전달된다.
export const functions = getFunctions(app);